/* eslint-disable no-underscore-dangle */
// underscore-dangle é uma convenção adotada pelo leafelt para atributos privados

import { SVG } from 'leaflet';

// Adicionando método setZIndex para possibilitar sobreposição de camadas geoJson na mesma pane
SVG.include({
  setZIndex: function (zIndex) {
    if (this._container) this._container.style.zIndex = zIndex;
  },
});
